module.exports = __webpack_public_path__ + "img/Armbian64_128.695dcf80.png";